
import * as types from '../actions/types';


const INITIAL_STATE = {
    authenticated: false,
    profile: {
        customer: null
    },
    cards: [],
    pointsHistory: [],
    earn: [],
    points: 0
}
export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case types.SIGN_IN_SUCCCESS:
            return {
                authenticated: true,
                profile: action.payload.profile,
                cards: action.payload.cards,
                pointsHistory: [],
                earn: []
            };

        case types.SET_CARDS:
            return { ...state, cards: action.payload };

        case types.SET_PROFILE:
            return { ...state, profile: action.payload };

        case types.SET_CUSTOMER_POINTS_HISTORY:

            return {
                ...state,
                pointsHistory: action.payload.pointsHistory,
                earn: action.payload.earn,
                points: action.payload.points
            };

        case types.SIGN_OUT_SUCCCESS:
            return INITIAL_STATE;

        default:
            return state;
    }
}